export function rootAction(type, data=undefined) {
  return {
    type: type,
    data: data
  }
}
